import React, { FC } from 'react'
import Strings from 'project/localisation'
import { Constants } from 'common/utils'
import imageResize from 'project/image-proxy-web' // we need this to make JSX compile
import { Tenant } from 'common/tenant'

type CopyrightType = {
  tenant?: Tenant
}

const Copyright: FC<CopyrightType> = ({ tenant = Tenant.UK }) => {
  const { abn, acn, company_number, ico_number, mlr_number } =
    Constants.companyInformation
  return (
    <ul className='list-unstyled d-flex footer__copyright'>
      <li className='d-md-inline d-block copyright-text'>
        <div className='d-flex align-items-center justify-content-center'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='25'
            fill='none'
          >
            <path
              fill='#1D1D1F'
              d='m14.912 6.575-2.06 3.176 1.164.102-4.926 4.303 1.881-3.176h-.856l.856-4.405H6.785V18.43h3.793v-2.284l2.845-2.485v4.77h3.794V6.574h-2.305Z'
            />
            <circle
              cx='12'
              cy='12.502'
              r='11'
              stroke='#1D1D1F'
              strokeWidth='2'
            />
          </svg>
          <p
            dangerouslySetInnerHTML={{
              __html: Strings.formatString(
                `${tenant === Tenant.AU ? Strings.copyrightAu : Strings.copyright}`,
                new Date().getFullYear(),
              ),
            }}
            className='text-small mb-0 ps-2'
          ></p>
        </div>
      </li>

      {tenant === Tenant.AU ? (
        <li className='ps-0 ps-lg-4 d-md-flex align-items-center d-block copyright-numbers'>
          <ul className='w-100 list-unstyled d-flex justify-content-center text-small'>
            <li className=''>
              ABN: {abn} | ACN: {acn}
            </li>
          </ul>
        </li>
      ) : (
        <li className='ps-0 ps-lg-4 d-md-flex align-items-center d-block copyright-numbers'>
          <ul className='w-100 list-unstyled d-flex justify-content-center text-small'>
            <li className='list-border-right'>
              {Strings.companyNo} {company_number}
            </li>
            <li className='list-border-right'>
              {Strings.mlrNumber} {mlr_number}
            </li>
            <li>
              {Strings.icoNumber} {ico_number}
            </li>
          </ul>
        </li>
      )}
    </ul>
  )
}

export default Copyright
